import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsContentBlockCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-content-block{display:block;contain:content;display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:white;margin-bottom:1rem}.fds-content-block--icon--large .fds-content-block__inner__header{margin-bottom:0.25rem}.fds-content-block__inner__header{display:flex;align-items:center;margin-bottom:1rem}.fds-content-block__inner__header__title{display:inline-block;margin-bottom:0.25rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.5;letter-spacing:0;margin:0 auto 0 0;word-break:break-word}.fds-content-block__inner p:last-child{margin-bottom:0 !important}.fds-content-block__inner--bg-blue{color:#3B87DD}.fds-content-block__inner--bg-red{color:#E31C0D}.fds-content-block__inner--bg-green{color:#70C31F}.fds-content-block__inner--bg-yellow{color:#FFBA20}.fds-content-block--secondary{display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:rgba(12, 72, 153, 0.0475);margin-bottom:1rem}.fds-content-block--transparent{display:block;padding:1rem 1rem 1.5rem;border-radius:4px;background-color:transparent;margin-bottom:1rem}.fds-content-block--icon{padding:0.5rem 0.5rem 0;display:flex}.fds-content-block--icon svg{height:100%;width:100%}";

const FdsContentBlock = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.variant = 'primary';
    this.icon = undefined;
    this.size = 'large';
    this.color = 'blue';
  }
  /**
   * If the icon prop exists, then show the icon.
   */
  setIcon() {
    if (this.icon) {
      return h("span", { class: `fds-content-block__inner--bg-${this.color} m-r-l` }, h("fds-icon", { name: this.icon, size: this.size === 'small' ? '24px' : '48px' }));
    }
    else {
      return null;
    }
  }
  getHeaderSection() {
    // NOTE: Depending on variant, the header styling will change
    const header = !!this.el.querySelector('[slot="header"]');
    if (header) {
      return (h("header", { class: `fds-content-block__inner__header` }, this.size === 'small' ? this.setIcon() : null, h("div", { class: "fds-content-block__inner__header__title" }, h("slot", { name: "header" })), h("slot", { name: "button" })));
    }
    else {
      return null;
    }
  }
  render() {
    const classes = {
      'fds-content-block': true,
      [`fds-content-block--${this.variant}`]: true,
      [`fds-content-block--icon--large`]: this.size === 'large' && this.icon ? true : false
    };
    const classesInner = {
      'fds-content-block__inner': true,
      [`fds-content-block--icon`]: this.icon ? true : false
    };
    return (h(Host, { class: classes }, h("section", { class: classesInner }, this.size === 'large' ? this.setIcon() : null, h("div", null, this.getHeaderSection(), h("slot", null)))));
  }
  get el() { return getElement(this); }
};
FdsContentBlock.style = fdsContentBlockCss;

export { FdsContentBlock as fds_content_block };
